import { Box, Button, Flex, Heading, Image, Text } from '@chakra-ui/react';
import { trackEvent } from '@diamond/shared/utils';
import { TRACKING_EVENTS, TRACKING_PAGES } from '@diamond/sol-buyer/constant';
import { ChevronRight } from '@mui/icons-material';
import { useRouter } from 'next/router'; // Import useRouter
import type { FC } from 'react';

interface PromoCardProps {
  promoNumber: string | number;
  promoText: string;
  onClick?: () => void;
  width?: string;
  height?: string; // Add height prop
  bgPosition?: string; // Add height prop
}

const CardPromoRight: FC<PromoCardProps> = ({
  promoNumber,
  promoText,
  onClick,
  width,
  height = 'auto',
  bgPosition = 'right',
}) => {
  const router = useRouter(); // Initialize useRouter

  const handleClick = () => {
    const tab = promoText.includes('Khusus') ? 'khusus' : 'umum';
    trackEvent(TRACKING_EVENTS.CLICK_PROMO_OTHERS, {
      section_name: 'Product Highlight | Promo',
      page_name: TRACKING_PAGES.BERANDA,
    });
    router.push(`/promo?tab=${tab}`);
  };

  const isBgRight = bgPosition === 'right';

  return (
    <Box
      pl={{ base: '2' }}
      width={'var(--card-width-carousel)'}
      height={{ base: height }}
      cursor="pointer"
      onClick={handleClick}
      _hover={{ bg: 'transparent', color: 'var(--chakra-colors-blue)' }}
      _focus={{ boxShadow: 'none' }}
    >
      <Box
        w="full"
        minWidth={{ base: width ? width : '150px', lg: '100%' }}
        h={{ base: 'full' }}
        paddingBottom={{ base: 2, md: 4 }}
        border="1px"
        borderColor="gray.33"
        rounded="lg"
        overflow="hidden"
        position="relative"
        display="flex"
        flexDir="column"
        bg="white"
      >
        {/* Background image */}
        <Box
          as={Image}
          src={
            isBgRight
              ? '/images/bg_shape_right.png'
              : '/images/bg_shape_left.png'
          }
          position="absolute"
          top={height ? -10 : 0}
          right={isBgRight ? 0 : undefined}
          height={height ? '120%' : '75%'}
          objectFit="cover"
          objectPosition="right"
          zIndex={0}
          alt="Background pattern"
        />
        {/* Content */}
        <Flex
          justifyContent="center"
          alignItems="center"
          position="relative"
          zIndex={1}
          pt={8}
          pb={12}
          h="90%"
        >
          {promoNumber !== '0' ? (
            <Heading
              fontSize={{ base: '34px', sm: '34px', md: '48px', lg: '48px' }}
              fontWeight="semibold"
              color="#00003D"
              textAlign="center"
            >
              {promoNumber}
            </Heading>
          ) : null}
        </Flex>

        <Box
          display="flex"
          bottom={4}
          left={0}
          right={0}
          alignItems="end"
          justifyContent="center"
          fontWeight="bold"
        >
          <Button
            color="inherit"
            bg="transparent"
            rightIcon={<ChevronRight color="inherit" fontSize="small" />} // Change color to inherit
            _hover={{ bg: 'transparent' }}
            _focus={{ boxShadow: 'none' }}
            fontSize={{ base: '14px' }}
            fontWeight="bold"
          >
            {promoText}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default CardPromoRight;
